const PaymentStatusTypes = {
    GET_ORDERS_BY_MOBILE: "GET_ORDERS_BY_MOBILE",
    CHECK_PAYMENT_BY_ORDER_ID: "CHECK_PAYMENT_BY_ORDER_ID"
};

export { PaymentStatusTypes };
